<template>
	<div class="paas-list-container">
		<div class="paas-lis-query-area ivu-row">
			<div class="paas-list-query-icon">
				<Icon type="md-search" />
			</div>
			<div class="paas-query-group">
				<Input
					v-model="queryParam.query_LIKE_name"
					placeholder="角色名称"
					@on-change="queryTableDatas('param')"
				>
					<span slot="prepend">角色名称:</span>
				</Input>
			</div>
			<div class="paas-query-group">
				<Button type="primary" class="paas-oper-btn" icon="md-checkmark" @click="paasSelectSaveData">保存</Button>
			</div>
		</div>
		<div class="paas-select-content">
			<Tag
				color="primary"
				v-for="item in datas"
				:key="item.id"
				:name="item.name"
				closable
                ref="listWrap"
				@on-close="paasDeleteSelectedTag($event,item.id)"
			>{{item.name}}</Tag>
		</div>
		<div class="paas-table-wrap">
			<Table
				border
				ref="selection"
				:data="tableData"
				:columns="tableColumns"
				stripe
				@on-selection-change="selectTableDataChange"
			></Table>
			<div class="paas-table-pager">
				<Page
					:total="totalRecords"
					@on-change="changePage"
					show-total
					show-sizer
					@on-page-size-change="changePageSize"
				></Page>
			</div>
		</div>
	</div>
</template>

<script>
	import metaList from "@assets/js/list/meta-list.js";
	export default {
		mixins: [metaList],
		props: {
			multiple: {
				type: Boolean,
				default: false
			},
			datas: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		data() {
			return {
				serviceUrl: "/sys/role",
				currentIdFiledName: "id",
				queryParam: {
					queryOrderBy_: "",
					query_LIKE_name: ""
				},
				tableColumns: [
					{
						type: "selection",
						key: "sysRoleId",
						width: 60,
						align: "center"
					},
					{
						title: "角色名称",
						key: "name"
					},
					{
						title: "角色描述",
						key: "sysRoleDesc"
					}
				],
				selectedDatas: [],
				initFlag: false,
				isSelectList: true
			};
		},
		methods: {
			paasInitSelectedTable() {
                this.initFlag = false;
                this.queryTableDatas();
             },
            paasSelectSaveData() {
              this.$emit("save", this.datas);
            },
            /**
             * 选择页面方法
             */
            paasDeleteSelectedTag(event, name) {
              for(let i = 0; i < this.datas.length; i++) {
                if(this.datas[i][this.currentIdFiledName] === name) {
                  this.datas.splice(i, 1);
                  break;
                }
              }
              for(let i = 0; i < this.tableSelectedDatas.length; i++) {
                if(this.tableSelectedDatas[i][this.currentIdFiledName] === name) {
                  this.tableSelectedDatas.splice(i, 1);
                  break;
                }
              }
              for(let i = 0; i < this.tableData.length; i++) {
                if(this.tableData[i][this.currentIdFiledName] === name) {
                  this.$refs.selection.toggleSelect(i);
                  break;
                }
              }
            },
		},
		watch: {
			tableSelectedDatas: function(val) {
				let currPageDataIds = [];
				for (let i = 0; i < this.datas.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (
							this.datas[i][this.currentIdFiledName] ===
							this.tableData[j][this.currentIdFiledName]
						) {
							currPageDataIds.push(this.datas[i][this.currentIdFiledName]);
							break;
						}
					}
				}
				for (let i = 0; i < currPageDataIds.length; i++) {
					let exist = false;
					for (let j = 0; j < this.tableSelectedDatas.length; j++) {
						if (
							currPageDataIds[i] ===
							this.tableSelectedDatas[j][this.currentIdFiledName]
						) {
							exist = true;
							break;
						}
					}
					if (!exist) {
						for (let n = 0; n < this.datas.length; n++) {
							if (this.datas[n][this.currentIdFiledName] === currPageDataIds[i]) {
								this.datas.splice(n, 1);
								break;
							}
						}
					}
				}
				for (let j = 0; j < this.tableSelectedDatas.length; j++) {
					let flag = false;
					for (let n = 0; n < this.datas.length; n++) {
						if (
							this.datas[n][this.currentIdFiledName] ===
							this.tableSelectedDatas[j][this.currentIdFiledName]
						) {
							flag = true;
							break;
						}
					}
					if (!flag) {
						this.datas.push(this.tableSelectedDatas[j]);
					}
				}
			},
			datas: function(val) {
				if (!this.initFlag) {
					this.$refs.selection.selectAll(false);
					for (let i = 0; i < this.datas.length; i++) {
						for (let j = 0; j < this.tableData.length; j++) {
							if (
								this.datas[i][this.currentIdFiledName] ==
								this.tableData[j][this.currentIdFiledName]
							) {
								this.$refs.selection.toggleSelect(j);
								break;
							}
						}
					}
				}
				this.initFlag = true;
			},
			tableData: function(val) {
				for (let i = 0; i < this.datas.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (
							this.datas[i][this.currentIdFiledName] ==
							this.tableData[j][this.currentIdFiledName]
						) {
							this.tableData[j]._checked = true;
							break;
						}
					}
				}
			}
		}
	};
</script>
<style scoped>
	@import "../../../assets/css/paas/paas-list.css";
</style>
